import { useQuery } from '@tanstack/react-query';
import { getCompanyPackage } from 'services/crm-checkout-service';
import { delay } from 'utils/delay';

const useCompanyPackage = (delayMs?: number, isAuthorizedPage = true) => {
  const fetchCompanyPackage = async () => {
    if (delayMs) {
      await delay(delayMs);
    }
    return getCompanyPackage({});
  };
  const { data, isLoading: isCompanyPackageLoading } = useQuery({
    queryKey: ['currentPackage'],
    queryFn: fetchCompanyPackage,
    enabled: isAuthorizedPage
  });

  return { companyPackage: data?.data?.data, companyPachageResponseLevel: data?.data?.level, isCompanyPackageLoading };
};

export default useCompanyPackage;
